import { GameType, PhaseKind, PlayersAmount } from '@api/models/enums';
import { Game } from '@api/models/game.entity';
import { GamesV2Query } from '@api/models/games-v2.query';
import { MoneyPot } from '@api/models/money-pot.entity';
import { Phase } from '@bussiness/custom-models/game.custom-models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export interface GamesCreateAction {
	gameType: GameType;
	playersAmount: PlayersAmount;
	name: string;
	password?: string;
	moneyPot?: MoneyPot | string;
}

export interface GamesSetAction {
	game: Game;
}

export interface GamesGetCurrentAction {
	_id: string;
	goToRolePicker?: boolean;
}

export interface GamesLoadAction {
	query: GamesV2Query;
}

export interface GamesLoadSuccessAction {
	games: Game[];
}

export interface GamesJoinAction {
	gameId: string;
}

export interface GameUpdateAction {
	viewers?: number;
	over?: boolean;
}

export interface GameAddPhaseAction {
	kind: PhaseKind;
}

export interface GameAddPhaseSuccessAction {
	phase: Phase;
}

export interface GameSearchMoneyPotAction {
	name: string;
}

export interface GameSearchMoneyPotSuccessAction {
	moneyPots: MoneyPot[];
}

export const GamesActions = createActionGroup({
	source: 'Games',
	events: {
		create: props<GamesCreateAction>(),
		createSuccess: props<GamesSetAction>(),

		getCurrent: props<GamesGetCurrentAction>(),
		getCurrentSuccess: props<GamesSetAction>(),

		load: props<GamesLoadAction>(),
		loadSuccess: props<GamesLoadSuccessAction>(),
		loadNextSuccess: props<GamesLoadSuccessAction>(),

		join: props<GamesJoinAction>(),

		finishSuccess: emptyProps(),

		updateSuccess: props<GameUpdateAction>(),

		addPhase: props<GameAddPhaseAction>(),
		addPhaseSuccess: props<GameAddPhaseSuccessAction>(),

		moveToNextPhase: emptyProps(),

		searchMoneyPot: props<GameSearchMoneyPotAction>(),
		searchMoneyPotSuccess: props<GameSearchMoneyPotSuccessAction>(),
	},
});
